import { render, staticRenderFns } from "./formMenuBar.vue?vue&type=template&id=b613630a&scoped=true"
import script from "./formMenuBar.vue?vue&type=script&lang=js"
export * from "./formMenuBar.vue?vue&type=script&lang=js"
import style0 from "./formMenuBar.vue?vue&type=style&index=0&id=b613630a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613630a",
  null
  
)

export default component.exports